<template>
  <div class="operation-report-show-body-form-item flex flex-col">
    <div
      class="form-item-label aisea-text-16-700-dark-gray"
      :class="{
        required: required,
        'is-editing': isEditing,
        'has-errors': hasErrors,
      }"
    >
      {{ label }}
    </div>
    <div class="form-item-value-unit-edit flex aisea-text-16-400-dark-gray">
      <div class="form-item-value-edit w-full">
        <vs-textarea
          class="form-item-value-edit-input aisea-text-16-400-dark-gray w-full"
          :name="name"
          v-model="value"
          v-validate="vValidate"
          :disabled="disabled"
          @change="onChange"
        ></vs-textarea>
      </div>
      <div
        class="form-item-value-unit flex-shrink-0 flex items-center"
        v-show="hasUnit"
      >
        {{ unit }}
      </div>
    </div>
    <div
      class="nullable-label flex items-center aisea-text-16-400-dark-gray"
      v-if="hasNullableLabel"
    >
      <vs-checkbox
        v-model="nullableChecked"
        :color="checkBoxColor"
        :disabled="disabled"
        @change="onChange"
      >
        <span>{{ nullableLabel }}</span>
      </vs-checkbox>
    </div>
  </div>
</template>

<script>
import isEmpty from "lodash/isEmpty";
import isString from "lodash/isString";
import isNil from "lodash/isNil";
import { ColorMixin } from "@/mixins";

const { AISEA_COLOR } = ColorMixin.data();

const EVENTS = {
  CHANGE: "change",
};

export default {
  name: "FormItemLongText",
  props: {
    label: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String, // validation のために必要
      required: true,
    },
    initialValue: {
      type: String,
      default: "",
    },
    unit: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // 編集中かどうか
    isEditing: {
      type: Boolean,
      default: false,
    },

    nullableLabel: {
      type: String,
      required: false,
    },
    isNullableChecked: {
      type: Boolean,
      default: false,
    },
    hasReportFormVersionItemValue: {
      type: Boolean,
      default: false,
    },
    defaultValue: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      value: null,
      nullableChecked: false,
      isDefaultValueInserted: false, // default値を挿入したかどうか -> defaultValueの更新が無限ループになるのを防ぐのに使う
    };
  },
  watch: {
    initialValue: {
      handler() {
        const {
          hasReportFormVersionItemValue,
          defaultValue,
          initialValue,
          onChange,
        } = this;
        if (
          !hasReportFormVersionItemValue &&
          !isNil(defaultValue) &&
          defaultValue !== ""
        ) {
          if (this.isDefaultValueInserted) return;
          this.value = defaultValue;
          onChange(); // デフォルト値を使用する場合に、そのまま更新リクエストできるようにする
        } else {
          this.value = initialValue;
        }
        this.isDefaultValueInserted = true;
      },
      immediate: true,
    },
    isNullableChecked: {
      handler() {
        this.nullableChecked = this.isNullableChecked;
      },
      immediate: true,
    },
    vValidate() {
      this.$nextTick(async () => {
        await this.$validator.validateAll(); // nullableLabel の変更時にバリデーションを効かせる
      });
    },
  },
  computed: {
    hasUnit() {
      return isString(this.unit) && !isEmpty(this.unit);
    },
    isNullable() {
      if (!this.hasNullableLabel) return !this.required;
      return this.nullableChecked === true;
    },
    vValidate() {
      const required = this.required && !this.isNullable ? "required|" : "";
      return `${required}`;
    },
    hasErrors() {
      return this.errors.has(this.name);
    },
    hasNullableLabel() {
      const { nullableLabel } = this;
      return isString(nullableLabel) && !isEmpty(nullableLabel);
    },
    checkBoxColor() {
      return AISEA_COLOR.BLUE;
    },
  },
  methods: {
    onChange() {
      const { disabled, value, nullableChecked } = this;
      if (disabled) return;
      this.$emit(EVENTS.CHANGE, { value, nullableChecked });
    },
  },

  beforeDestroy() {
    this.isDefaultValueInserted = false;
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";

.operation-report-show-body-form-item {
  min-height: 90px;
  padding: 18px 0;
  row-gap: 4px;

  .form-item-value-unit-edit {
    gap: 18px;
    padding-right: 18px;
  }
  .form-item-value-edit-input {
    margin-bottom: 0;
    border: none !important; // 不要なスタイルを削除
    ::v-deep .vs-textarea {
      resize: vertical; // リサイズは縦方向のみ許可
      height: 130px;
      border: 1px solid rgba(0, 0, 0, 0.2);
      &:disabled {
        resize: none;
        background-color: revert;
        opacity: 0.6;
      }
    }
  }

  .form-item-label.is-editing {
    &.has-errors {
      color: $aisea-red; // エラー発生時に項目名を赤くする
    }

    // 必須の赤い点
    &.required:after {
      content: " *";
      font-size: 14px;
      color: $aisea-red;
      font-weight: 700;
      font-family: $aisea-font-family;
    }
  }
  .nullable-label {
    gap: 20px;
  }
}
</style>
